import AdobeMain from './adobe/adobe-main';

/**
 * Event-Listener for Global Array scAnalyticsDataArray
 * Each events passed objects in AnalyticsEventHandler and call correspondent analytics
 */
class AnalyticsEventHandler {
	init() {
		if ( typeof scAnalyticsDataArray !== 'undefined' ) {
			const pushEvents = ( arr, callback ) => {
				arr.push = ( e ) => {
					Array.prototype.push.call( arr, e );
					callback( arr );
				};
			};

			/**
			 * queue of objects and pass it correspondent analytics
			 * @param {Object} scAnalyticsDataArray - collections of events objects
			 * @example
			 * pushEvents({event: 'ctaClick', title: document.title}, callback)
			 */

			/* eslint-disable no-undef*/
			//Disabled since scAnalyticsDataArray is Global Variable
			pushEvents( scAnalyticsDataArray, function ( newScAnalyticsDataArray ) {
				const cnt = document.querySelector( 'meta[name="sc:country"]' )
					? document.querySelector( 'meta[name="sc:country"]' ).getAttribute( 'content' )
					: null;

				newScAnalyticsDataArray.filter( ( obj ) => {
					if ( window.adobeDataLayer ) {
						//ignore if digitalData is not present.
						AdobeMain.handleDigitalDataPush( obj );
					}

					newScAnalyticsDataArray.shift();

					return '';
				} );
			} );
			/* eslint-enable no-undef*/
		}
	}
}

const instance = new AnalyticsEventHandler();
instance.init();

export default instance;
